module.exports = __webpack_public_path__ + "static/privat-223d4c2ed0b61324a268196201741ffe.webm";